/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {SettlementDetailTitleComponent} from './settlement-detail-title.component';

@NgModule({
    declarations: [SettlementDetailTitleComponent],
    exports: [
        SettlementDetailTitleComponent
    ]
})
export class SettlementDetailTitleModule {
}
